/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "@/dto/api.endpoint.dto";
import {
  apiErrorResponse,
  apiSuccessResponse,
  forceLogout,
} from "@/services/requests/response.request";
import {
  requestHeaders,
  requestLoginHeader,
} from "@/services/requests/header.request";
import { localKey } from "@/dto/local.key.dto";
import { globals } from "@/main";
import { accessToken, refreshToken } from "@/services/utils/helper.util";
import { apiKey } from "@/dto/api.key.dto";

export const getProfileService = async (params: string): Promise<any> => {
  const headers = await requestHeaders();

  return await globals.$axios
    .get(api.profile + params, {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};

export const loginService = async function (body: any): Promise<any> {
  return await globals.$axios
    .post(api.login, body, requestLoginHeader)
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};

export const regenerateTokenService = async function (): Promise<any> {
  const body = {
    refreshToken: refreshToken?.value,
    accessTokenExpireSecond: 60,
  };

  return await globals.$axios
    .post(api.refreshToken, body, requestLoginHeader)
    .then((response: any) => {
      if (response?.status === 201 || response?.status === 200) {
        localStorage.setItem(
          localKey?.accessToken,
          response?.data?.data?.[apiKey?.accessToken]
        );
        localStorage.setItem(
          localKey?.refreshToken,
          response?.data?.data?.[apiKey?.refreshToken]
        );

        accessToken.value = response?.data?.data?.[apiKey?.accessToken];
        refreshToken.value = response?.data?.data?.[apiKey?.refreshToken];
        return true;
      } else {
        return forceLogout();
      }
    })
    .catch((error: any) => {
      console.error("Regenerate Token Error", error?.response?.data);
      return forceLogout();
    });
};

export const regenerateTokenServiceInterceptor =
  async function (): Promise<any> {
    const body = {
      refreshToken: refreshToken?.value,
      accessTokenExpireSecond: 60,
    };

    return await globals.$axios
      .post(api.refreshToken, body, requestLoginHeader)
      .then((response: any) => {
        if (response?.status === 201 || response?.status === 200) {
          localStorage.setItem(
            localKey?.accessToken,
            response?.data?.data?.[apiKey?.accessToken]
          );
          localStorage.setItem(
            localKey?.refreshToken,
            response?.data?.data?.[apiKey?.refreshToken]
          );

          accessToken.value = response?.data?.data?.[apiKey?.accessToken];
          refreshToken.value = response?.data?.data?.[apiKey?.refreshToken];
          return true;
        } else {
          return forceLogout();
        }
      })
      .catch((error: any) => {
        console.error("Regenerate Token Error", error?.response?.data);
        return forceLogout();
      });
  };

export const logoutService = async function (): Promise<any> {
  const body = {
    refreshToken: refreshToken,
  };

  return await globals.$axios
    .post(api.refreshToken, body, requestLoginHeader)
    .then(() => {
      localStorage.removeItem(localKey?.accessToken);
      localStorage.removeItem(localKey?.refreshToken);

      location.reload();
    })
    .catch(() => {
      location.reload();
    });
};
